import React from 'react'
import styles from './styles.css'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'

@withMutation(gql`
  mutation validarPago($preferenceId: ID!, $reference: String!, $status: String!, $paymentId: String) {
    validarPago(preferenceId: $preferenceId, reference:$reference, status: $status, paymentId: $paymentId) 
  }
`)

@withMessage
export default class Success extends React.Component {

  static propTypes = {
    payment_id: PropTypes.string,
    status: PropTypes.string,
    external_reference: PropTypes.string,
    merchant_order_id: PropTypes.string,
    validarPago: PropTypes.func
  }

  state = {
    loading: true,
    success: false,
    message: ""
  }

  async validarPago(preferenceId, reference, status, paymentId){
    
    let data = await this.props.validarPago({
      preferenceId: preferenceId,
      reference: reference,
      status: status,
      paymentId: paymentId
    },
    {
      refetchQueries: [ 'planSignaturesCount', 'packsSignaturesCount' ]
    })
    console.log("Data: " + JSON.stringify(data) )
    this.setState(
      {
        loading: false,
        success: data.validarPago.success,
        message: data.validarPago.message
      }
      )
  }

  renderContent(){
    if(this.state.loading){
      return (
        <div>
            <p>Validando Pago...</p>
        </div>
      )
    } else {
      if(this.state.success){
        return(
          <div>
              <p>Pago exitoso!</p>
              <p>Has comprado exitosamente</p>
              <p><b>{this.state.message}</b></p>
          </div>
        )
      } else {
        return (
          <div>
            <p>No fue posible procesar el pago:</p>
            <p><b>{this.state.message}</b></p>
          </div>
        )
      }
      
    }
  }

  render() {
    console.log(this.props.location.query)
    if(this.state.loading)
      this.validarPago(
        this.props.location.query.preference_id, 
        this.props.location.query.external_reference, 
        this.props.location.query.status,
        this.props.location.query.payment_id 
      )
      
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Informe de Pago</h3>
          </div>
          <div className="content">
            { this.renderContent() }
          </div>         
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Payment/Success/index.js